import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSeo } from "@/lib/useSeo";
import { getList } from "@/lib/api";
import { IMG } from "@/lib/images";
import BookCard from "@/components/BookCard";
import { PageHeader } from "@/components/Editorial";

const CATEGORIES = ["Tous", "Ésotérisme", "Médiumnité", "Développement personnel", "Deuil", "Poésie", "Autobiographie", "Fiction / fantasy", "Feel good", "Érotisme", "Spiritualité"];

export default function Books() {
  const [cat, setCat] = useState("Tous");
  const isLoading = false;
  const books = [
{ id: 1, title: "Deuil et signes de l’au-delà", genre: "Deuil", slug: "deuil-et-signes-de-l-au-dela" },
{ id: 2, title: "Chroniques d’une médium pas comme les autres", genre: "Médiumnité", slug: "chroniques-d-une-medium-pas-comme-les-autres" },
{ id: 3, title: "Les secrets de la positivité", genre: "Feel good", slug: "les-secrets-de-la-positivite" },
{ id: 4, title: "365 messages inspirants", genre: "Spiritualité", slug: "365-messages-inspirants" },
{ id: 5, title: "PoeVie", genre: "Poésie", slug: "poevie" },
{ id: 6, title: "Un autre regard, mémoires d’une médium", genre: "Autobiographie", slug: "un-autre-regard-memoires-d-une-medium" },
{ id: 7, title: "Dream Even", genre: "Fiction / fantasy", slug: "dream-even" },
{ id: 8, title: "Ésotérisme Book", genre: "Ésotérisme", slug: "esoterisme-book" }
];

  useSeo({
    title: "Les livres",
    description: "La bibliothèque de Dorothée Lancelot : ésotérisme, médiumnité, développement personnel, deuil, poésie, autobiographie et fiction.",
    path: "/livres",
    keywords: ["livres Dorothée Lancelot", "livre ésotérisme", "livre médiumnité", "livre développement personnel", "livre sur le deuil", "livre spiritualité", "auteure ésotérisme", "acheter livre médium"],
  });
const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
   const filtered = cat === "Tous" ? books : books.filter((b) => norm(b.genre).includes(norm(cat)) || norm(cat).includes(norm(b.genre)));


  return (
    <div>
      <PageHeader
        eyebrow="La bibliothèque"
        title="Les livres de Dorothée Lancelot"
        intro="Une bibliographie qui traverse plusieurs univers : l'ésotérisme et son histoire, la médiumnité, le deuil, le développement personnel, la poésie et la fiction."
        image={IMG.booksCandle}
      />
<div className="dl-container -mt-6 mb-8 text-sm text-[#F3E9D2]/70">
Pour prolonger certains univers de mes livres, découvrez aussi{" "}
<a href="/mediuminite" className="dl-link">la médiumnité</a>,{" "}
<a href="/deuil" className="dl-link">le deuil</a> et{" "}
<a href="/histoire-esoterisme" className="dl-link">
l’histoire de l’ésotérisme
</a>.
</div>
      <section className="dl-container py-14">
        <div className="flex flex-wrap gap-2.5 mb-14">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`book-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => setCat(c)}
              className={`px-4 py-2 text-[0.72rem] tracking-wide uppercase border transition-colors ${
                cat === c ? "bg-[#C6A76A] text-[#050814] border-[#C6A76A]" : "border-[rgba(198,167,106,0.3)] text-[#F3E9D2]/70 hover:border-[#C6A76A]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {isLoading ? (
          <p className="text-[#F3E9D2]/50">Chargement…</p>
        ) : filtered.length === 0 ? (
          <p className="text-[#F3E9D2]/50">Aucun livre dans cette catégorie pour le moment.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-12">
            {filtered.map((b) => <BookCard key={b.id} book={b} />)}
          </div>
        )}
      </section>
    </div>
  );
}
